import axios from 'axios'

axios.defaults.withCredentials = true

export default {
    state : { 
        baseUrl:process.env.API_URL,
        deal:{},
        deals:[],
        dealCustomFields:[]
    },
    getters : {
        deals:(state)=>{
            return state.deals
        },
        deal:(state)=>{
            return state.deal
        },
        dealCustomFields:(state)=>{
            return state.dealCustomFields
        }
    },
    mutations : { 
        deal(state,deal){
            state.deal = deal
        },
        deals(state,deals){
            state.deals = deals
        },
        dealCustomFields(state,dealCustomFields){
            state.dealCustomFields = dealCustomFields
        }
    },
    actions : { 
        updateDeals({state,commit},form){

            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/updateDeals`,form)
                .then(response => {
                    console.log("updateDeals action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        /*
                        commit('organization',response.data.content.organization)
                        commit('user',response.data.user)
                        commit('users',response.data.users)
                        commit('organizationCustomFields',response.data.content.customFields)
                        resolve(response.data)
                        */
                       resolve(response.data)
                    }else{
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
            
        },
        deleteDeals({state,commit},form){

            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/deleteDeals`,form)
                .then(response => {
                    console.log("deleteDeals action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        /*
                        commit('organization',response.data.content.organization)
                        commit('user',response.data.user)
                        commit('users',response.data.users)
                        commit('organizationCustomFields',response.data.content.customFields)
                        resolve(response.data)
                        */
                       resolve(response.data)
                    }else{
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
            
        },
        getDealsForTable({state,commit},form){

            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/getDealsForList`,form)
                .then(response => {
                    console.log("getDealsForList action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        commit('deals',response.data.content.deals)
                        commit('user',response.data.user)
                        commit('users',response.data.users)
                        resolve(response.data)
                    }else{
                        resolve(false)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
            
        }
    }
}